import HttpRequest from './HttpRequest'

export default class AuthProvider extends HttpRequest {
  constructor () {
    super(process.env.VUE_APP_API)
  }

  login (token) {
    return this.post('/users/login', {
      tokenReference: token
    })
  }
}
